import ExchangeReport from '../components/ExchangeReport';

function BuyReport() {
  return <ExchangeReport type="buy" />;
}

export default BuyReport;
